module.exports = __webpack_public_path__ + "img/device_1006_3.02b0cee8.svg";